<template>
  <v-card>
    <!-- <v-card-title>Probabilidad en el tiempo</v-card-title> -->
    <!-- <v-card-title class="pa-0 caption ml-2">
      <v-spacer></v-spacer>
      <span>
        {{$ml.get("highest_similarity")}} : 
        {{((similarityPercent || 0)*100).toFixed(2)}} %
      </span>
    </v-card-title> -->
    <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="auto" class="ml-2">            
            <div style="height: 100%; text-align: center;">
              
              <img
                :src="currentImage"
                @error = "currentImage = '/img/no_img_found.png'"
                @click="openImageModal"
                class="overlay-image d-block mx-auto"          
                crossorigin=""
                style="cursor: pointer;"
              />
              
              <span> {{$ml.get('video_clipping')}} </span>
            </div>
              <!-- :lazy-src="$logos.mark || ($vuetify.theme.dark ? $logos.login_night : $logos.login)" -->
             <v-progress-linear
                indeterminate
                color="cyan"
                :active="loadingCrop"
              ></v-progress-linear>
          </v-col>
          <v-col cols="9">            
            <div class="chart-container">
              <canvas ref="lineChart"></canvas>
            </div>
          </v-col>
          <v-col cols="1" class="mt-3">     
            <div style="height: 100%; text-align: center;">                     
              <img
                :src="currentFramePhoto"
                @error="currentFramePhoto = '/img/no_img_found.png'"
                @click="openImageModal"
                class="frame-photo d-block mx-auto"          
                crossorigin=""
                v-if="currentFramePhoto"
                style="cursor: pointer;"
              />
              <video
                ref="videoElement"
                class="video-overlay d-block mx-auto"          
                crossorigin=""
                muted
                v-if="videoSrc && !currentFramePhoto"
                :src="videoSrc"
                @loadeddata="onVideoLoaded"
                playsinline
                preload="metadata"
              ></video>
              <span>
                {{ $ml.get("similarity")}}: {{currentPercent}} ;
                {{ $ml.get("time")}}: {{ currentTimeVideo ? currentTimeVideo: ''}}
              </span>
            </div>
          </v-col>
        </v-row>
    </v-card-text>
    
    <!-- Modal para mostrar imagen ampliada -->
    <v-dialog v-model="showImageModal" max-width="90vw" max-height="90vh">
      <v-card>
        <v-card-title class="headline">
          {{ $ml.get('frame_information') }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showImageModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pa-0">
          <v-container fluid class="pa-0">
            <v-row no-gutters>
              <!-- Imagen del rostro recortado -->
              <v-col cols="6" class="pa-2">
                <div class="text-center">
                  <h4>{{ $ml.get('cropped_face') }}</h4>
                  <img
                    :src="currentImage"
                    
                    class="modal-image"
                    style="max-width: 100%; max-height: 60vh; object-fit: contain;"
                  />
                </div>
              </v-col>
              
              <!-- Imagen completa del frame -->
              <v-col cols="6" class="pa-2">
                <div class="text-center">
                  <h4>{{ $ml.get('full_frame') }}</h4>
                  <img
                    :src="currentFramePhoto"
                    @error="currentFramePhoto = '/img/no_img_found.png'"
                    class="modal-image"
                    style="max-width: 100%; max-height: 60vh; object-fit: contain;"
                  />
                </div>
              </v-col>
            </v-row>
            
            <!-- Información adicional -->
            <v-row class="pa-4">
              <v-col cols="12">
                <v-card outlined>
                  <v-card-title class="subtitle-1">
                    {{ $ml.get('frame_information') }}
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <strong>{{ $ml.get('similarity') }}:</strong> 
                        {{ getSimilarityDisplay() }}
                      </v-col>
                      <v-col cols="6">
                        <strong>{{ $ml.get('time') }}:</strong> 
                        {{ getTimeDisplay() }}
                      </v-col>
                      <v-col cols="6">
                        <strong>{{ $ml.get('timestamp') }}:</strong> 
                        {{ currentFrameData ? currentFrameData.timestamp : (maxProbData && maxProbData.timestamp ? new Date(maxProbData.timestamp).toLocaleString() : 'N/A') }}
                      </v-col>
                      <v-col cols="6">
                        <strong>{{ $ml.get('bbox') }}:</strong> 
                        <span v-if="currentFrameData && currentFrameData.bbox">
                          x: {{ (currentFrameData.bbox.x * 100).toFixed(1) }}%, y: {{ (currentFrameData.bbox.y * 100).toFixed(1) }}%
                        </span>
                        <span v-else-if="maxProbData && maxProbData.bbox">
                          x: {{ (maxProbData.bbox.x * 100).toFixed(1) }}%, y: {{ (maxProbData.bbox.y * 100).toFixed(1) }}%
                        </span>
                        <span v-else>N/A</span>
                      </v-col>
                      <v-col cols="6" v-if="maxProbData && maxProbData.frame_idx">
                        <strong>{{ $ml.get('frame_index') }}:</strong> {{ maxProbData.frame_idx }}
                      </v-col>
                      <v-col cols="6" v-if="maxProbData && maxProbData.bbox_prob">
                        <strong>{{ $ml.get('bbox_probability') }}:</strong> {{ (maxProbData.bbox_prob * 100).toFixed(2) }}%
                      </v-col>
                      <v-col cols="6" v-if="maxProbData && maxProbData.faceId">
                        <strong>{{ $ml.get('face_id') }}:</strong> {{ maxProbData.faceId.substring(0, 8) }}...
                      </v-col>
                      <v-col cols="6" v-if="maxProbData && maxProbData.photo_uuid">
                        <strong>{{ $ml.get('photo_uuid') }}:</strong> {{ maxProbData.photo_uuid.substring(0, 8) }}...
                      </v-col>
                      <v-col cols="12" v-if="maxProbData && maxProbData.infovideo">
                        <strong>{{ $ml.get('video_info') }}:</strong>
                        <div class="ml-4">
                          <div><strong>{{ $ml.get('fps') }}:</strong> {{ maxProbData.infovideo.fps }}</div>
                          <div><strong>{{ $ml.get('resolution') }}:</strong> {{ maxProbData.infovideo.frameWidth }}x{{ maxProbData.infovideo.frameHeight }}</div>
                          <div><strong>{{ $ml.get('total_frames') }}:</strong> {{ maxProbData.infovideo.total_frames }}</div>
                          <div><strong>{{ $ml.get('total_faces') }}:</strong> {{ maxProbData.infovideo.total_faces }}</div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showImageModal = false">
            {{ $ml.get('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { Chart } from "chart.js";
import { min } from "moment-timezone";
import VideoProcessor from "@/class/VideoProcessor.js"
// this.$Helper.isChromeOrChromium()
export default {
  name: "LineChart",
  props: ["infoData", "openVideo", "maxProbData", "similarityPercent", "videoSrcGrid","Threshold"],
  data() {
    return {
      chart: null,
      listData:[],
      videoSrc: "", // Reemplaza con tu vide / https://www.example.com/video.mp4
      currentImage: null,
      currentFramePhoto: null, // Imagen completa del frame
      currentFrameData: null, // Datos completos del frame actual
      showImageModal: false, // Control del modal
      timeoutCrop : null,
      loadingCrop:false,
      videoProcessor: null,
      currentPercent: 0,
      currentTimeVideo: null,
    };
  },
  mounted() {
    this.videoProcessor = new VideoProcessor(this.videoSrcGrid, this.$URL);
    this.videoProcessor.load()
    this.createChart();
    
    
    this.$nextTick(async ()=>{

          this.loadingCrop = true
          
          
         
          
          this.videoProcessor.captureFrame(this.maxProbData)
          .then(result => {
            this.loadingCrop = false
            // result.croppedFacePhoto es la imagen recortada del rostro
            this.currentImage = result.croppedFacePhoto;
            // result.framePhoto es la imagen completa del frame
            this.currentFramePhoto = result.framePhoto;
            // Guardar datos completos del frame
            this.currentFrameData = result.originalData;
           
          })
          .catch(err => {
            this.loadingCrop = false
            
          });

        })
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
    // Revoke the object URL to prevent memory leaks
    if (this.currentImage) {
      URL.revokeObjectURL(this.currentImage);
    }
    if (this.currentFramePhoto) {
      URL.revokeObjectURL(this.currentFramePhoto);
    }
  },
  watch:{
    infoData(items){
      const { tempLabels, tempData }=this.renderDataLineChart();
      this.updateChart(tempLabels, tempData);
      
    },
    Threshold(){
      
      this.chart.options.scales.yAxes[0].ticks.min =parseInt(Math.abs(this.Threshold)*100);
      this.chart.update();
    }
  },
  methods: {
    renderDataLineChart(){
      let tempData=[];
      let tempLabels=[];
      this.listData=[]; // set array
      if(this.infoData && this.infoData.length){        
        
        this.infoData.forEach((maxItem)=>{
          tempLabels.push(this.$Helper.formatTime(parseFloat(maxItem.currentTime.toFixed(2))))
          tempData.push((Math.abs(maxItem.similarity)*100).toFixed(2))
          
          this.listData.push(maxItem);          
        })
        
        
         // groupBySeconds.forEach(x=>{
          // if(x.similarity > 0 && !tempLabels.includes(parseFloat(x.currentTime, 2))){            
          // }
        // })
         
        
      }
      return {tempLabels, tempData}
    },
    completarSerieCadaMinuto(data, startTimeMs, endTimeMs) {
      const result = [];

      // Crear un Map para acceso rápido: key = minuto redondeado, value = similarity
      const datosPorMinuto = new Map();
      data.forEach(d => {
        const minuto = Math.floor(d.currentTime / 60000) * 60000; // redondear al minuto
        datosPorMinuto.set(minuto, d.similarity);
      });

      // Iterar minuto a minuto
      let currentTime = Math.floor(startTimeMs / 60000) * 60000;
      const endTime = Math.floor(endTimeMs / 60000) * 60000;

      while (currentTime <= endTime) {
        result.push({
          currentTime: currentTime,
          similarity: datosPorMinuto.get(currentTime) ?? 0
        });

        currentTime += 60000; // avanzar 1 minuto
      }

      return result;
    },
    createChart() {
      const ctx = this.$refs.lineChart.getContext("2d");
      const { tempLabels, tempData }=this.renderDataLineChart();
      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: tempLabels,//["00:00", "01:00", "02:00", "03:00", "04:00", "05:00"], // Etiquetas para el eje X (tiempo)
          datasets: [
            {
              label: this.$ml.get("similarity"),
              data: tempData, //[0.1, 0.4, 0.6, 0.8, 0.5, 0.9], // Datos para el eje Y (probabilidad)
              borderColor: "rgba(54, 162, 235, 1)",
              backgroundColor: "rgba(54, 162, 235, 0.2)",
              borderWidth: 1.5,
              pointRadius: 3,
              pointHoverRadius: 5,
              // pointBackgroundColor: '#42A5F5',  // Color normal del punto
              // pointHoverBackgroundColor: '#FF5722', // Cambia el color al pasar el mouse
              // pointBorderColor: '#fff',
              // pointHoverBorderColor: '#FF5722',
            },
          ],
        },
        options: {
          responsive: true,
          onClick: this.handleClick,
          maintainAspectRatio: false,
           onHover: async (event, elements) => {
            // Verificar si el cursor está sobre un punto
            
            if (elements.length > 0) {
              const datasetIndex = elements[0]._datasetIndex;
              const dataIndex = elements[0]._index;
              
              if (this.currentHoveredIndex != dataIndex) {
               
                this.currentHoveredIndex = dataIndex;
                

                this.currentPercent=(this.chart.data.datasets[datasetIndex].data[dataIndex] || "")+"%";
                this.currentTimeVideo=this.chart.data.labels[dataIndex] || "";
                this.loadingCrop = true
                
                
                
                this.videoProcessor.captureFrame(this.listData[dataIndex])
                .then((result) => {
                  this.loadingCrop = false
                  if (this.currentImage) {
                    URL.revokeObjectURL(this.currentImage);
                  }
                  if (this.currentFramePhoto) {
                    URL.revokeObjectURL(this.currentFramePhoto);
                  }
                  // result.croppedFacePhoto es la imagen recortada del rostro
                  this.currentImage = result.croppedFacePhoto;
                  // result.framePhoto es la imagen completa del frame
                  this.currentFramePhoto = result.framePhoto;
                  // Guardar datos completos del frame
                  this.currentFrameData = result.originalData;
                  
                })
                .catch(err => {
                  this.loadingCrop=false
                  
                });

                //const result = await this.videoProcessor.captureFrame(this.listData[dataIndex].currentTime)
                //this.currentImage =result.croppedImageUrl

              }else{
                //this.currentHoveredIndex = null;
              }
             

              // const time = this.chart.data.labels[dataIndex];
              // const probability = this.chart.data.datasets[datasetIndex].data[dataIndex];

              // Llamar a updateVideo con el índice del punto
             

              
              this.updateVideo(this.listData[dataIndex]);
            }
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: function(tooltipItem) {
                  let value = tooltipItem.raw; // Convierte a porcentaje
                  return String(value) + '%';
                }
              },
              enabled: true,             
            },
          },
          scales: {
            yAxes: [{
                ticks: {
                    min: Math.abs(this.Threshold)*100, // Establece el mínimo en 5
                    // (Opcional) Establece un máximo
                }
            }],
            x: {
              type: 'time',
              time: {
                unit: 'minute', // o 'second' si querés más granularidad
                stepSize: 1 // fuerza la separación constante
              },
              ticks: {
                autoSkip: false // muestra todos los ticks
              },
              title: {
                display: true,
                text: this.$ml.get("time") + " (HH:MM)", // Título del eje X
              },
            },
            y: {
              title: {
                display: true,
                text: this.$ml.get("similarity"), // Título del eje Y
              },
              ticks: {
                callback: function(value) {
                  return String(value.toFixed(0)) + '%'; // Convierte a porcentaje
                }
              },
              
            },
          },
        },
      });
      this.renderVideo()
    },
    async renderVideo(){
      if(this.listData && this.listData.length &&  this.listData[0]?.infovideo?.url){
        this.videoSrc=this.videoSrcGrid;// ||  await this.$Helper.loadVideoBlob(this.listData[0]?.infovideo?.url); // this.$URL+
      }      
    },
    onVideoLoaded(){
      
      if(this.maxProbData){
        this.$nextTick(async ()=>{
          //const resultloaded = await this.videoProcessor.captureFrame(this.maxProbData.currentTime)// this.listData[dataIndex]
          //this.currentImage =resultloaded.croppedImageUrl

          this.updateVideo(this.maxProbData)          
        })
      }
    },
    handleClick(event) {
      // Obtener los elementos en el punto clicado
      const elements = this.chart.getElementsAtEventForMode(
        event,
        "nearest", // Buscar el punto más cercano al clic
        { intersect: true },
        true
      );

      if (elements.length) {
        // const datasetIndex = elements[0].datasetIndex;
        const dataIndex = elements[0]._index;

        // Obtener datos relacionados al punto clicado
        // const label = this.chart.data.labels[dataIndex]; // Etiqueta en el eje X
        // const value = this.chart.data.datasets[datasetIndex].data[dataIndex]; // Valor en el eje Y

        
        if(dataIndex>=0 && this.listData && this.listData.length && this.listData[dataIndex]){
          // Actualizar datos del punto clickeado
          this.currentPercent = (this.chart.data.datasets[0].data[dataIndex] || "") + "%";
          this.currentTimeVideo = this.chart.data.labels[dataIndex] || "";
          this.currentHoveredIndex = dataIndex;
          
          // Capturar frame del punto clickeado
          this.loadingCrop = true;
          
          this.videoProcessor.captureFrame(this.listData[dataIndex])
          .then((result) => {
            this.loadingCrop = false;
            if (this.currentImage) {
              URL.revokeObjectURL(this.currentImage);
            }
            if (this.currentFramePhoto) {
              URL.revokeObjectURL(this.currentFramePhoto);
            }
            
            this.currentImage = result.croppedFacePhoto;
            this.currentFramePhoto = result.framePhoto;
            this.currentFrameData = result.originalData;
            
            
            
            // Crear objeto con datos del frame capturado para el modal del componente padre
            const frameData = {
              ...this.listData[dataIndex],
              croppedFacePhoto: result.croppedFacePhoto,
              framePhoto: result.framePhoto,
              originalData: result.originalData
            };
            
            // Llamar al método del componente padre con los datos del frame
            this.openVideo(frameData, this.listData, this.videoSrc);
          })
          .catch(err => {
            this.loadingCrop = false;
            
            // En caso de error, llamar al método padre con los datos originales
            this.openVideo(this.listData[dataIndex], this.listData, this.videoSrc);
          });
        }
        // alert(`Tiempo: ${label}\nProbabilidad: ${value}`); // Mostrar los datos en una alerta
      }
    },
    updateVideo(item) {
      
      const time=item?.currentTime;
      if(typeof time !== "number" || isNaN(time)  || !isFinite(time)){
        return
      }
      const video = this.$refs.videoElement;
      // Ajusta el tiempo del video al índice del punto en la gráfica
      if(video){    

        // video.currentTime = time//index * 10; // Por ejemplo, cada punto representa 10 segundos
        // if (video.paused) video.play();
        // video.stop()
        
        // video.addEventListener("seeked", this.captureImage(item, video), { once: true });
        // this.captureImage(item, video)
        video.addEventListener("seeked", this.onSeeked(item, video));
        video.currentTime = time;
      }
    },
    updateChart(newLabels, newData) {
      this.chart.data.labels = newLabels; // Actualizar labels
      this.chart.data.datasets[0].data = newData; // Modificar datos
      this.chart.update(); // Refrescar gráfico
    },

    openImageModal() {
     
      this.showImageModal = true;
    },

    getSimilarityDisplay() {
      if (this.currentPercent) {
        return this.currentPercent;
      }
      if (this.maxProbData && this.maxProbData.similarity) {
        return (this.maxProbData.similarity * 100).toFixed(2) + '%';
      }
      return 'N/A';
    },

    getTimeDisplay() {
      let timeInSeconds = null;
      
      if (this.currentTimeVideo) {
        // Si currentTimeVideo ya está en formato mm:ss, lo devolvemos tal como está
        if (this.currentTimeVideo.includes(':')) {
          return this.currentTimeVideo;
        }
        // Si es un número, lo convertimos
        timeInSeconds = parseFloat(this.currentTimeVideo);
      } else if (this.maxProbData && this.maxProbData.currentTime) {
        timeInSeconds = parseFloat(this.maxProbData.currentTime);
      }
      
      if (timeInSeconds !== null && !isNaN(timeInSeconds)) {
        return this.formatTimeToMMSS(timeInSeconds);
      }
      
      return 'N/A';
    },

    formatTimeToMMSS(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    },

    captureOnceReady(item, video){
      if (video.readyState >= 2) {  
        
        this.captureImage(item, video);
      }else{
       
        const timer = setTimeout(()=>{
          this.captureOnceReady(item,video);
          clearTimeout(timer);
        }, 100)
      }
    },

    onSeeked (item, video){
      video.removeEventListener("seeked", this.onSeeked);
      //this.captureOnceReady(item, video);
    },


    captureImage(item, video) {
        if(this.timeoutCrop){
          clearTimeout(this.timeoutCrop);
        }
        this.loadingCrop=true;

        this.timeoutCrop = setTimeout(()=>{                  
          if (!(video instanceof HTMLVideoElement)) {
            
            return;
          }
          const canvas = document.createElement("canvas");
          video.crossOrigin = null;

          let width  = item.bbox.w *  parseInt(video.videoWidth || canvas.width);
          let height  = item.bbox.h *  parseInt(video.videoHeight || canvas.height);
          let startX = item.bbox.x *  parseInt(video.videoWidth || canvas.width) ;
          let startY = item.bbox.y *  parseInt(video.videoHeight || canvas.height);
          
          const scaleFactor = 1.01; // Aumenta la resolución del canvas
          canvas.width = width * scaleFactor;
          canvas.height = height * scaleFactor;

          const ctx = canvas.getContext("2d", { willReadFrequently: true });
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = "high";
          
          
          try{
            ctx.drawImage(
              video,
              startX ,
              startY ,
              width ,
              height ,
              0,
              0,
              width,
              height
              );
            //this.currentImage = canvas.toDataURL("image/jpeg", 0.95);

          }catch(error){
            
          }finally{
            clearTimeout(this.timeoutCrop);
            this.timeoutCrop=null;
            this.loadingCrop=false;
            // video.removeEventListener("seeked", this.captureFrame);
          }
        }, 1000);
      },
  }, // methods
};
</script>

<style scoped>
/*canvas {
  max-width: 100%;
  height: 150px;
}*/
.chart-container {
  position: relative;
  width: 100%; /* Ancho ajustable */
  height: 150px; /* Cambia esta propiedad para ajustar la altura */
}
canvas {
  position: relative;
  z-index: 3;
  max-width: 98%;
  height: 100%;
}
.video-overlay {
/*  position: absolute;*/
  top: 10%;
  right: 0%;
  width: 200px;
  height: auto;
  z-index: 2;
  border: 2px solid #ccc;
  border-radius: 8px;
  background: #000;
}
.frame-photo {
/*  position: absolute;*/
  top: 10%;
  right: 0%;
  width: 200px;
  height: auto;
  max-height: 150px;
  z-index: 2;
  border: 2px solid #ccc;
  border-radius: 8px;
  background: #000;
  object-fit: contain;
  transition: transform 0.2s ease;
}

.frame-photo:hover {
  transform: scale(1.05);
  border-color: #2196F3;
}

.modal-image {
  border: 2px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
.overlay-image {
/*  position: absolute;*/
  left: 10px; /* Siempre alineado a la izquierda */
  width: 120px;
  height: 100%;
  max-height: 150px;
  z-index: 3;
  top : 0%;
  border: 2px solid #ccc;
  border-radius: 8px;
  background: #000;
  transition: transform 0.2s ease;
}

.overlay-image:hover {
  transform: scale(1.05);
  border-color: #2196F3;
}
</style>
